import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Converts mind map nodes to text nodes for Liveblocks synchronization
 * @param nodes - Array of nodes from the graph, including mind map nodes
 * @param userId - ID of the user who owns the nodes
 * @param edges - Array of edges from the graph
 * @returns Object containing updated nodes and edges
 */
export const removeMindMapNodesAndEdges = (nodes, edges) => {
  // Map old mindMapStarterNode IDs to new textNode IDs
  const mindMapNodeIds = [];

  const updatedNodes = nodes
    .map(node => {
      if (node.type === 'mindMapStarterNode' || node.type === 'mindMapNode') {
        mindMapNodeIds.push(node.id);
        return null;
      }
      return node;
    })
    .filter(node => node !== null);

  // Filter out customEdges and update connectionEdge sources
  const updatedEdges = edges.filter(
    edge => !mindMapNodeIds.includes(edge.source) && !mindMapNodeIds.includes(edge.target)
  );

  return { nodes: updatedNodes, edges: updatedEdges };
};

/**
 * Cleans nodes before syncing to Liveblocks by removing internal properties and nullifying text content
 * @param nodes - Array of nodes from the graph to be cleaned
 * @returns Array of cleaned nodes with internals removed and text content nullified for text nodes
 */
export const cleanNodesForLiveblocks = nodes => {
  return nodes.map(node => {
    const { internals, ...nodeWithoutInternals } = node;
    if (node.type === 'textNode') {
      return {
        ...nodeWithoutInternals,
        data: {
          ...nodeWithoutInternals.data,
          text: null,
        },
      };
    }
    return nodeWithoutInternals;
  });
};
